import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "@/components/App";
import * as Sentry from "@sentry/react";
import { SENTRY_DSN } from "@/constants";
import { ThemeProvider } from "@/context/theme";
import logger from "@/services/logtain-logger-service";

/* global Office */

const rootElement: HTMLElement | null = document.getElementById("container");
const root = createRoot(rootElement, {
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

/* Render application after Office initializes */

Office.onReady(() => {
  logger.info("Word Addin up");
  if (SENTRY_DSN) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: process.env.NODE_ENV,
      debug: process.env.NODE_ENV === "development",
      enabled: process.env.NODE_ENV !== "development",
      integrations: [
        // If you're using react router, use the integration for your react router version instead.
        // Learn more at https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
      ],
      // Set tracesSampleRate to 1.0 to capture 100% of transactions for tracing.
      // Learn more at https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
      tracesSampleRate: 1.0,
      // Capture Replay for 10% of all sessions plus for 100% of sessions with an error
      // Learn more at https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    });
  }

  root?.render(
    <ThemeProvider>
      <App />
    </ThemeProvider>
  );
});

if ((module as any).hot) {
  (module as any).hot.accept("@/components/App", () => {
    const NextApp = require("@/components/App").default;
    root?.render(NextApp);
  });
}
